import { DatePipe } from '@angular/common';
import {
  Component,
  computed,
  effect,
  inject,
  model,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FollowUpsUtilsService } from '@app/modules/follow-ups/services/follow-ups-utils.service';
import { ResultsUtilsService } from '@app/modules/reports/services/results-utils.service';
import { GetResultAction } from '@app/modules/reports/store/results.actions';
import { ResultsState } from '@app/modules/reports/store/results.state';
import { ServiceDataUtilsService } from '@app/modules/service-data/services/service-data-utils.service';
import { SigneeState } from '@core/store/signees/signees.state';
import { CoreUtilsService } from '@core/utils/core-utils.service';
import { NgbActiveModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { UserDisplayComponent } from '@shared/components/user-display/user-display.component';
import { RequirePermissionDirective } from '@shared/directives/require-permission.directive';

@Component({
  selector: 'app-result-details-dialog',
  imports: [
    TranslatePipe,
    DatePipe,
    NgbTooltip,
    UserDisplayComponent,
    RequirePermissionDirective,
  ],
  templateUrl: './result-details-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './result-details-dialog.component.scss',
})
export class ResultDetailsDialogComponent {
  private store = inject(Store);
  private modal = inject(NgbActiveModal);
  protected coreUtilsService = inject(CoreUtilsService);
  protected followUpsUtils = inject(FollowUpsUtilsService);
  protected resultsUtils = inject(ResultsUtilsService);
  protected serviceDataUtils = inject(ServiceDataUtilsService);

  protected resultId = model<string>(null);
  result = computed(() => {
    return this.store.selectSignal(ResultsState.getResult)()(this.resultId());
  });
  signee = computed(() => {
    return this.store.selectSignal(SigneeState.getSigneeById)()(
      this.result()?.signeeId
    );
  });
  importerInfo = computed(() => {
    return this.store.selectSignal(ResultsState.getImporterInfo)()(
      this.result().dataVersion
    );
  });

  constructor() {
    effect(() => {
      this.store.dispatch(new GetResultAction(this.resultId()));
    });
  }

  dismiss() {
    this.modal.dismiss();
  }

  protected readonly Object = Object;
}
